import React, { useEffect, useRef, useState } from "react";
import { differenceInDays, isBefore, isAfter, format } from "date-fns";
import { base_url } from "../../../utils/AxiosConfig";
import axios from "axios";
import SnackbarNotification from "../../../utils/SnackbarNotification";
import dayjs from "dayjs";

const LeaveRejoinPopup = ({
  setPopUpData,
  PopUpData,
  getDataApproved,
  onClose,
}) => {
  const [earlyOrLate, setEarlyOrLate] = useState(null);
  const [toDate, SetToDate] = useState("");
  const [rejoinDate, setRejoinDate] = useState("");

  useEffect(() => {
    if (PopUpData) {
      SetToDate(PopUpData.ToDate.split("T")[0]);
      setRejoinDate(new Date().toISOString().split("T")[0]);
    }
  }, [PopUpData]);

  const storedUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  const companyCode = storedUserDataArray[0]?.cmpcode || null;

  const handleDateChange = (e) => {
    const selected = new Date(e.target.value);
    const toDateNew = new Date(toDate);
    const rejoinDateState = format(selected, "DD-MMM-YYYY ");
    setRejoinDate(rejoinDateState);

    if (isBefore(selected, toDateNew)) {
      const daysDifference = differenceInDays(toDateNew, selected);
      setEarlyOrLate(`Early by ${daysDifference} Days`);
    } else if (isAfter(selected, toDateNew)) {
      const daysDifference = differenceInDays(selected, toDateNew);
      setEarlyOrLate(`Late by ${daysDifference} Days`);
    } else {
      setEarlyOrLate("On time");
    }
  };

  const [snackbar, setSnackbar] = useState({
    open: false,
    severity: "success",
    message: "",
  });

  const showSnackbar = (severity, message) => {
    setSnackbar({ open: true, severity, message });
  };

  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const SaveRejoinApi = async () => {
    try {
      const response = await axios.post(
        `${base_url}/api/PersonalInfoLeaveStatusUpdate/${companyCode}/REJOIN/${
          PopUpData?.serialcode || null
        }/${PopUpData?.Name}/${
          PopUpData?.Ticket || "Not Applicable"
        }/${PopUpData?.approvalnote || "nil"}`,
      );

      if (response?.data) {
        showSnackbar("success", "Rejoin Success");
        setTimeout(() => {
          onClose();
          getDataApproved();
        }, 1000);
      }
    } catch (error) {
      showSnackbar("error", "Rejoin Error");
      console.error("SaveRejoinApiErr", error);
    }
  };

  return (
    <>
      {/* Background overlay */}
      {/* <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
       
        <div className="bg-white rounded-lg shadow-lg w-full max-w-2xl">
          <div className="flex justify-between items-center border-b px-4 py-2">
            <h5 className="font-bold text-lg">Rejoin Update</h5>
            <button
              className="text-gray-500 hover:text-red-500"
              onClick={onClose}
            >
              ✕
            </button>
          </div>

          <div className="p-4">
            {/* <p className="text-sm text-gray-500 mb-2">Rejoin</p> 
            <table className="w-full border">
              <tbody>
                <tr>
                  <td className="border px-2 py-1">Leave Taken</td>
                  <td className="border px-2 py-1">{PopUpData?.Leave_Category}</td>
                </tr>
                <tr>
                  <td className="border px-2 py-1">Leave From</td>
                  <td className="border px-2 py-1">
                    <input
                      className="form-control w-full border px-2 py-1 rounded"
                      type="date"
                      value={PopUpData?.FromDate.split("T")[0]}
                      disabled
                    />
                  </td>
                </tr>
                <tr>
                  <td className="border px-2 py-1">Leave To</td>
                  <td className="border px-2 py-1">
                    <input
                      className="form-control w-full border px-2 py-1 rounded"
                      type="date"
                      value={PopUpData?.ToDate.split("T")[0]}
                      disabled
                    />
                  </td>
                </tr>
                <tr>
                  <td className="border px-2 py-1">Rejoined On</td>
                  <td className="border px-2 py-1">
                    <input
                      className="form-control w-full border px-2 py-1 rounded"
                      type="date"
                      value={rejoinDate}
                      onChange={handleDateChange}
                    />
                  </td>
                </tr>
                <tr>
                  <td className="border px-2 py-1">Early or Late By</td>
                  <td className="border px-2 py-1">
                    <b className="text-blue-500">{earlyOrLate || "N/A"}</b>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="flex justify-end border-t px-4 py-2">
            <button
              className="bg-gray-300 px-3 py-1 rounded mr-2"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              className="bg-green-500 text-white px-3 py-1 rounded"
              onClick={SaveRejoinApi}
            >
              Save
            </button>
          </div>
        </div>
      </div> */}

      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
        <div className="bg-white w-full max-w-2xl rounded-lg shadow-lg">
          {/* Header */}
          <div className="flex items-center justify-between border-b px-5 py-3 bg-[#2663EB] rounded-t-lg">
            <h5 className="text-lg font-semibold text-white">Rejoin Update</h5>

            <button
              onClick={onClose}
              className="text-white hover:text-gray-800 text-3xl"
            >
              &times;
            </button>
          </div>

          {/* Body */}
          <div className="p-4">
            {/* <p className="text-sm text-gray-500 mb-4">Rejoin</p> */}

            <div className="overflow-x-auto scrollbar-none rounded-sm m-2">
              <table className="w-full text-sm border border-gray-200 ">
                <tbody className="divide-y">
                  <tr>
                    <td className="p-2 font-medium">Leave Taken</td>
                    <td className="p-2">{PopUpData?.Leave_Category}</td>
                  </tr>

                  <tr>
                    <td className="p-2 font-medium">Leave From</td>
                    <td className="p-2">
                      {/* <input
                        className="w-full border rounded-md px-2 py-1 text-sm bg-gray-100"
                        type="date"
                        value={PopUpData?.FromDate?.split("T")[0]}
                        disabled
                      /> */}
                      <input
                        type="date"
                        className="w-full border rounded-md px-2 py-1 text-sm bg-gray-100"
                        value={
                          PopUpData?.FromDate
                            ? dayjs(PopUpData.FromDate).format("YYYY-MM-DD")
                            : ""
                        }
                        disabled
                      />
                    </td>
                  </tr>

                  <tr>
                    <td className="p-2 font-medium">Leave To</td>
                    <td className="p-2">
                      <input
                        className="w-full border rounded-md px-2 py-1 text-sm bg-gray-100"
                        type="date"
                        value={PopUpData?.ToDate?.split("T")[0]}
                        disabled
                      />
                    </td>
                  </tr>

                  <tr>
                    <td className="p-2 font-medium">Rejoined On</td>
                    <td className="p-2">
                      <input
                        className="w-full border rounded-md px-2 py-1 text-sm focus:ring-2 focus:ring-blue-500"
                        type="date"
                        value={rejoinDate || ""}
                        onChange={handleDateChange}
                      />
                    </td>
                  </tr>

                  <tr>
                    <td className="p-2 font-medium">Early Or Late By</td>
                    <td className="p-2">
                      <span className="text-blue-600 font-semibold">
                        {earlyOrLate || "N/A"}
                      </span>
                    </td>
                  </tr>

                  <tr className=" "></tr>
                </tbody>
              </table>
            </div>
            <div className="mt-4 w-full flex justify-center items-center">
              <button
                onClick={SaveRejoinApi}
                className="bg-blue-600 hover:bg-blue-700 text-white text-sm px-4 py-1.5 rounded-md transition"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Snackbar */}
      <SnackbarNotification
        open={snackbar.open}
        severity={snackbar.severity}
        message={snackbar.message}
        onClose={handleCloseSnackbar}
      />
    </>
  );
};

export default LeaveRejoinPopup;
